const accessToken = "";
const tokenExpirationDate = 0;
const user = {
    email: "innovalombia@gmail.com",
    lastName: "Tecno",
    name: "Innovalombia",
    picture: "",
    sub: "b8529984-56ab-4783-9fa9-a14fd7ce9a06"
};
const roles = ["undefined"];
const globalPermissions = ["user:GetOwn"];
const tenantPermissions = ["user:GetOwn"];
const merchantPermissions = ["user:GetOwn"];
const permissions = ["user:GetOwn"];
const error = {};

const state = {
    tokenExpirationDate,
    hasAdminRole: true,
    tenantWasSelected: false,
    accessToken,
    permissions,
    merchantPermissions,
    globalPermissions,
    tenantPermissions,
    roles,
    error,
    user,
    tenantName: "",
    tenantSlug: "",
    tenantId: "",
    needOnboardingUser: false,
    needOnboardingTenant: false,
    // billing-fase5-salida-planes: booleanos manuales del tenant
    // (`productsEnabled`, `linesEnabled`, …) que devuelve el backend.
    featureFlags: {},
    // portal-sesion-y-candados-optimizacion: núcleo de sesión de
    // sign-in/profile. `sessionCoreLoaded` queda en false en sesiones
    // guardadas antes de este cambio, para completarlas con un getProfile.
    pendingLegalDocuments: [],
    subscription: null,
    sessionCoreLoaded: false
};

export default state;
